export { env } from "./env";
export { Api } from "./api";
export { currentConfig, CONFIG } from "./config";
export { ModalIds } from "./modals";

export const REMOTE_IMAGES_URLS = ["https://www.ala.com", "https://ala.ai", "https://flocplatform.com", "https://chat.flocplatform.com"];
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
